function getCategories(state) {
  return state.games.taboo.categories;
}

export default getCategories;
